// extracted by mini-css-extract-plugin
export default {"component":"country-select-component_component_NNeUI"};